import EChartsReact from 'echarts-for-react'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import apiService from '../../api/ApiService'

const SinglePI = ({data,flag}) => {
    const [options,setOptions]=useState( {})
   
      useEffect(()=>{
            setOptions( {
                title: {
                  text: flag=='status'?'تعداد دام ها به تفکیک وضعیت':flag==='count'?'تعداد دام ها به تفکیک بهاربند':flag==='cycle'?'دام ها به تفکیک چرخه':'تعداد دام ها به تفکیک گردنبند',
                  subtext:`تعداد کل دام ها : ${data?.all}`,
                  left: 'center'
                },
                tooltip: {
                  trigger: 'item'
                },
                legend: {
                  orient: 'horizontal',
                  bottom: 'left',
                },
                series: [
                  {
                    type: 'pie',
                    
                    radius:['25%', '55%'],
                    itemStyle:{borderWidth:2,birderRadius:8},
                    data: flag==='status'?data?.status:flag==='count'?data?.count:flag==='cycle'?data?.cycle:data?.withSens,
                    emphasis: {
                      itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                    }
                  }
                ]
              })
      },[data])
  return (
    <div style={{minWidth:'280px',backgroundColor:'rgba(192,223,195,.1)',boxShadow:'0px 0px 3px 3px rgba(128,128,128,.2)',padding:'10px 2px',borderRadius:'10px'}}>
      <EChartsReact
      
      option={options}
  opts={{ renderer: 'svg', width: '290px', height: '400px' }}
  />
    </div>
  )
}

export default SinglePI
